<template>
  <div class="search-popup-container">
    <div class="search-popup-scroll">
      <div class="flex-div" v-for="field in fields" :key="field.id">
        <span class="field-label">{{ field.label }} :</span>
        <select v-if="field.type === 'select'" :id="field.id" v-model="formValues[field.id]" class="form-control"
          @keyup.enter="handleSearch">
          <option v-for="option in field.options" :key="option.value" :value="option.value">
            {{ option.label }}
          </option>
        </select>
        <input v-else :type="field.type" :id="field.id" v-model="formValues[field.id]" class="form-control"
          :placeholder="field.placeholder || ''" @keyup.enter="handleSearch">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchPopup',

  props: {
    searchParams: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      formValues: {},
      fields: [
        {
          id: 'delivery_status',
          label: '배송상태',
          type: 'select',
          options: [
            { value: '', label: '전체' },
            { value: '1', label: '배송완료' },
            { value: '2', label: '배송대기' },
            { value: '3', label: '회수중' },
            { value: '4', label: '회수완료' }
          ]
        },
        {
          id: 'delivery_method',
          label: '배송방법',
          type: 'select',
          options: [
            { value: '', label: '전체' },
            { value: '1', label: '내방' },
            { value: '2', label: '택배' },
            { value: '3', label: '물류' },
            { value: '4', label: '소독업체' },
            { value: '5', label: '공급업체' }
          ]
        },
        {
          id: 'orderType',
          label: '구분',
          type: 'select',
          options: [
            { value: '', label: '전체' },
            { value: 'normal', label: '구입' },
            { value: 'rental', label: '대여' },
            { value: 'oxygen', label: '산소' },
            { value: 'diabetes', label: '당뇨' },
            { value: 'assistance', label: '보장구' }
          ]
        },
        { id: 'name3', label: '품목명', type: 'text', placeholder: '품목명을 입력하세요' },
        { id: 'centerName', label: '센터명', type: 'text', placeholder: '센터명을 입력하세요' },
        { id: 'manager', label: '담당자', type: 'text', placeholder: '담당자명을 입력하세요' },
        { id: 'phone1', label: '연락처', type: 'text', placeholder: '연락처를 입력하세요' },
        {
          id: 'bcode',
          label: '바코드',
          type: 'text',
          placeholder: '바코드를 입력하세요'
        },
      ]
    }
  },

  created() {
    // 초기값 설정
    this.formValues = { ...this.searchParams };
  },

  methods: {
    getFormValues() {
      return this.formValues;
    },
    handleSearch() {
      // 부모 컴포넌트의 Swal 인스턴스에서 confirm 버튼 클릭 이벤트 발생
      const confirmButton = document.querySelector('.swal2-confirm');
      if (confirmButton) {
        confirmButton.click();
      }
    }
  }
}
</script>

<style scoped>
.search-popup-container {
  height: 55vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.search-popup-scroll {
  flex: 1;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.flex-div {
  display: flex;
  align-items: center;
  padding: 10px 0;
  width: 100%;
}

.field-label {
  width: 120px;
  flex-shrink: 0;
  font-weight: 600;
  text-align: right;
  padding-right: 15px;
}

.form-control {
  flex-grow: 1;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
  max-width: 300px;
}

.form-control:focus {
  border-color: #0f4c5c;
  outline: none;
  box-shadow: 0 0 0 2px rgba(15, 76, 92, 0.1);
}
</style>